import { Box, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
export default function Info() {
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f5f5f5",
        }}
      >
        <Container>
          <Grid container alignItems="center">
            <Grid container alignItems="center">
              <Grid size={{ xs: 12, md: 8 }}>
                <Box
                  sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    background: "#f5f5f5",
                    py: 1,
                  }}
                >
                  <Typography
                    component="div"
                    sx={{
                      display: "inline-block",
                      fontWeight: 600,
                      animation: "marquee 15s linear infinite",
                      "@keyframes marquee": {
                        "0%": {
                          transform: "translateX(100%)",
                        },
                        "100%": {
                          transform: "translateX(-100%)",
                        },
                      },
                    }}
                  >
                    Welcome to DHIS2 Portal | Health Services Information |
                    Real-time Monitoring & Reporting System
                  </Typography>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, md: 4 }}>
                <Box textAlign="center">
                  <Typography
                    sx={{
                      color: "red",
                      fontWeight: 400,
                      fontSize: "18 px",
                      mt: "auto",
                      animation: "blink 2s infinite",
                      "@keyframes blink": {
                        "0%": { opacity: 1 },
                        "50%": { opacity: 0 },
                        "100%": { opacity: 1 },
                      },
                    }}
                  >
                    DHIS 2 Free Helpline # 0800 909090
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}
